<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableElasticBlockStoreResourceAzureListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableElasticBlockStoreResourceAzureVue = {};
export default {
  name: "TableElasticBlockStoreResourceAzure",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountNameSearchIDVal: "",
      columns: [
        {
          title: this.$t("RAM.Azure.trusteeDisk.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.Azure.trusteeDisk.subscriptionName"),
          key: "subscriptionName"
        },
        {
          title: this.$t("RAM.Azure.trusteeDisk.subscriptionID"),
          key: "subscriptionId"
        },
        {
          title: this.$t("RAM.Azure.trusteeDisk.resourceGroup"),
          key: "resourceGroup"
        },
        {
          title: this.$t("RAM.Azure.trusteeDisk.diskConfig"),
          key: "type"
        },
        {
          title: this.$t("RAM.Azure.trusteeDisk.status"),
          key: "stateName"
        },
        {
          title: this.$t("RAM.Azure.trusteeDisk.owner"),
          key: "instanceId"
        },
        {
          title: this.$t("RAM.Azure.trusteeDisk.operatingSystem"),
          key: "os"
        },
        {
          title: this.$t("RAM.Azure.trusteeDisk.launchTime"),
          key: "createdTime"
        }
      ],
      tableElasticBlockStoreResourceAzureListData: []
    };
  },
  beforeCreate: function() {
    tableElasticBlockStoreResourceAzureVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountNameSearchID", function(accountNameSearchIDVal) {
      tableElasticBlockStoreResourceAzureVue.accountNameSearchIDVal = accountNameSearchIDVal;
    });
    eventBus.$on("companyId", function(val) {
      tableElasticBlockStoreResourceAzureVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableElasticBlockStoreResourceAzureVue.getElasticBlockStoreResourceAzureListData();
    },
    // 分页显示数据
    /****************************************************/
    getElasticBlockStoreResourceAzureListData: function() {
      this.$api.resourceManagement
        .queryPagingAzureDiskConfig({
          accountName:
            tableElasticBlockStoreResourceAzureVue.accountNameSearchIDVal,
          companyId: tableElasticBlockStoreResourceAzureVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableElasticBlockStoreResourceAzureListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableElasticBlockStoreResourceAzureVue.getElasticBlockStoreResourceAzureListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableElasticBlockStoreResourceAzureVue.getElasticBlockStoreResourceAzureListData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/ebs/TableElasticBlockStoreResourceAzure.vue